module.exports = __webpack_public_path__ + "static/media/badge_level_1_1.42ab9391.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges/badge_level_1_1.png
// module id = 487
// module chunks = 0